module.exports = __webpack_public_path__ + "media/images/281-crown-a8c1561ba74b6d9a2681937c5b875c89.png";